export type ParceiroTermosNavegador = {
  idioma: string
  fusoHorario: string
  latitude?: number
  longitude?: number
}

function readPosition(): Promise<{ latitude: number; longitude: number } | null> {
  if (!navigator.geolocation) return Promise.resolve(null)
  return new Promise((resolve) => {
    const timer = window.setTimeout(() => resolve(null), 4000)
    navigator.geolocation.getCurrentPosition(
      (position) => {
        window.clearTimeout(timer)
        resolve({
          latitude: Number(position.coords.latitude.toFixed(6)),
          longitude: Number(position.coords.longitude.toFixed(6)),
        })
      },
      () => {
        window.clearTimeout(timer)
        resolve(null)
      },
      { enableHighAccuracy: false, maximumAge: 60_000, timeout: 3500 },
    )
  })
}

export async function readParceiroTermosNavegador(): Promise<ParceiroTermosNavegador> {
  const position = await readPosition()
  return {
    idioma: navigator.language,
    fusoHorario: Intl.DateTimeFormat().resolvedOptions().timeZone,
    ...position,
  }
}
